import crypto from "crypto";

const ServiceBridgeController = {
    state: {
        GlobalWsStatus: false,
        GlobalWsConnection: null,
        GlobalWsAuth: window.localStorage.getItem('auth'),
        wait_messages: new Map(),
        handler_map: new Map(),
        heartbeat_interval: undefined,
        hard_restart: false
    },
    getters:{
        WsGetStatus: (state) => {
            return state.GlobalWsStatus
        },
        WsGetAuth: (state) => {
            return state.GlobalWsAuth
        },
        WsGetConnection: (state) => {
            return state.GlobalWsConnection
        },
        WSGetParserFromMap: (state) => (key) => {
            return state.handler_map.get(key)
        },
        getHardRestart: (state) =>{
            return state.hard_restart
        }
    },
    mutations: {
        WsSetStatus (state, new_status) {
            state.GlobalWsStatus = new_status
        },
        WsCreateHeartbeatInterval (state){
            state.heartbeat_interval = setInterval(() => this.dispatch("WS_CallHeartbeat"), 300000) // каждые 5 минут проверяем подключение.
        },
        WsDeleteHeartbeatInterval (state){
            clearInterval(state.heartbeat_interval)
            state.heartbeat_interval = undefined;
        },
        WsCreateHandler (state, handler_data) {
            state.handler_map.set(handler_data.topic, handler_data.func)
        },
        WsSetAuth (state, auth) {
            state.GlobalWsAuth = auth
        },
        WsSetConnection (state, new_connection) {
            state.GlobalWsConnection = new_connection
        },
        WsResetState (state) {
            state.GlobalWsConnection.close()
            state.GlobalWsStatus = false
            state.GlobalWsConnection = null
            state.GlobalWsAuth = ''
        },
        setHardRestart: (state, new_state) =>{
            state.hard_restart = new_state
        }
    },
    actions: {


        /**
         * Подключение к сервису ServiceBridge
         * @param {string} url_for_connect - строка с url для подключения
         * @example
         * `wss://${url_for_connect}`
         * @constructor
         */
        WSConnect(context, url_for_connect){
            try {
                /**
                 * хост получаем из настроек с сервера
                 */
                context.commit('WsSetConnection', new WebSocket(`wss://${url_for_connect}`))
                /**
                 * Указываем в системе, осуществилось ли подключение.
                 * Требуется что бы управлять таймерами и калбеками
                 */
                context.getters.WsGetConnection.onopen = () => {
                    context.commit('WsCreateHeartbeatInterval')
                    context.commit('WsSetStatus', true)
                    context.getters.WsGetConnection.onmessage = (event) => {
                        let cmd = JSON.parse(event.data)
                        let parser_func = context.getters.WSGetParserFromMap(cmd.action)
                        if(parser_func)
                            parser_func(cmd)
                    }
                }
                context.getters.WsGetConnection.onclose = () => {
                    context.commit("setHardRestart", true)
                    context.commit('WsDeleteHeartbeatInterval')
                    context.commit('WsSetStatus', false)
                }
                context.getters.WsGetConnection.onerror = (event) => {
                    context.commit('WsDeleteHeartbeatInterval')
                    console.log("WebSocket error: ", event);
                    context.commit('WsSetStatus', false)
                }
            } catch (e) {
                console.log(e)
            }
        },

        /**
         * Heartbeat
         **/
        WS_CallHeartbeat() {
            this.dispatch("WS_SendAction", {action: "PING", topic: undefined}).then()
            return
         },

        /** Отправка данных по сокету. В data требуется передать объект с содержанием
         * @param {Object} data - Входные данные для вызова события
         * @param {string} data.action - Имя события которое хочет вызвать frontend
         * @param {string} data.topic - Имя очереди с которой это событие связанно.
         * @example
         * this.$store.dispatch("WS_SendAction", { action: "SUBSCRIBE", topic: "device_update_main.0" })
         **/
        WS_SendAction(context, data) {
            let hash = crypto.createHash('md5').update(JSON.stringify(data)).digest('hex');
            if(context.state.wait_messages.get(hash)){
                return
            } else {
                context.state.wait_messages.set(hash,setTimeout(() => {
                    context.state.wait_messages.delete(hash)
                    this.getters.WsGetConnection.send(JSON.stringify({
                        action: data.action,
                        auth: this.getters.WsGetAuth,
                        topic: data.topic
                    }))
                }, data.timeout ?? 1000 ))
            }
        },
        /**
         * Вызов события подписки на топик
         * @param {string} data - объект с именем топика который мы хотим прослушивать и опциональным таймаутом на отправку запроса
         * @example
         * this.$store.dispatch("WS_Subscribe",`device_update_main.0`)
         **/
        WS_Subscribe(context, data) {
            this.dispatch("WS_SendAction", { action: "SUBSCRIBE", topic: data.topic, timeout: data.timeout })
            context.commit('WsCreateHandler', data)
        },
        /**
         * Вызов события отписки от топика
         * @param {string} topic - имя топика который мы перестаём
         * @example
         * this.$store.dispatch("WS_Unsubscribe",`device_update_main.0`)
         **/
        WS_Unsubscribe(context, topic) {
            this.dispatch("WS_SendAction", { action: "UNSUBSCRIBE", topic: topic })
        },
    }
}

export default ServiceBridgeController
